import { Separator as BaseSeparator } from "@base-ui/react/separator";
import { cn } from "../lib/cn";

export interface SeparatorProps extends Omit<BaseSeparator.Props, "className"> {
  className?: string;
}

export function Separator({ className, orientation = "horizontal", ...props }: SeparatorProps) {
  return (
    <BaseSeparator
      data-slot="separator"
      orientation={orientation}
      className={cn(
        "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch",
        className,
      )}
      {...props}
    />
  );
}
